import client from './client';

export default {
  loginUser: data => {
    return client.post('login', data).then(res => res.data);
  },
  logout: data => {
    return client.post('logout', data).then(res => res.data);
  }
}